import {CommonConfig} from '@employee-configs/common.config';
import * as EmployeeModels from '@employee-models/index';
import {UserRoleEnum} from '@shared-models/common.enums';
import {BadgeRequestCategoryEnum} from '@employee-models/data.enums';

export interface PhotoData {
    uId: string;
    name?: string;
    contentType?: string;
    length?: number;
    dataImage?: string;
    url?: string;
}

export interface RequestReason {
    categoryId?: number;
    reasonId?: number;
    name: string;
    placeholder: string;
    icon: string;
    roles?: Array<number>;
    isExtension?: boolean;
}

export interface FilterConfig {
    filterField: string;
    placeholder: string;
    noDataText: string;
    minHighlightLength: number;
    simpleView: boolean;
    strictFiltering: boolean;
    type: string;
    filterLimit: number;
}

export const VISITORS_REQUEST_REASONS: Array<RequestReason> = [
    {
        categoryId: BadgeRequestCategoryEnum.NonDeloitte,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'Non Deloitte visitors',
        placeholder: 'Non Deloitte visitors',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/non-deloitte.svg`
    },
    {
        categoryId: BadgeRequestCategoryEnum.MemberFirm,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'Member firm visitors',
        placeholder: 'Member firm visitors',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/member-firm.svg`
    },
    {
        categoryId: BadgeRequestCategoryEnum.ThirdPartyContractor,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: '3rd party contractor',
        placeholder: '3rd party contractor',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/3rd-contractors.svg`,
        roles: [UserRoleEnum.FacilitatorUSI, UserRoleEnum.SecurityUSI]
    },
    {
        categoryId: BadgeRequestCategoryEnum.CleContractor,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'CLE Badge requests',
        placeholder: 'Deloitte contractors request',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/3rd-contractors.svg`,
        roles: [UserRoleEnum.CLE]
    },
    {
        categoryId: BadgeRequestCategoryEnum.MdfWorkPermit,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'MDF work permit',
        placeholder: 'MDF work permit',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/3rd-contractors.svg`
    },
    {
        categoryId: BadgeRequestCategoryEnum.IdfWorkPermit,
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'IDF work permit',
        placeholder: 'IDF work permit',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/3rd-contractors.svg`
    },
];

export const DEFAULT_REQUEST_REASONS: Array<RequestReason> = [
    {
        reasonId: EmployeeModels.DE.BadgeReasonEnum.PhotoOnly,
        name: 'Photo only',
        placeholder: 'Updated Badge photo only, creates overlay, not new Badge',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/badge-replacement.svg`
    },
    {
        reasonId: 0,
        name: 'Name change',
        placeholder: 'I changed my name',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/changed-name.svg`
    },
    {
        reasonId: EmployeeModels.DE.BadgeReasonEnum.BadgeLost,
        name: 'Badge lost',
        placeholder: 'My badge was lost',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/badge-loss.svg`
    },
    {
        reasonId: EmployeeModels.DE.BadgeReasonEnum.BadgeStolen,
        name: 'Badge stolen',
        placeholder: 'My badge has been stolen',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/stolen.svg`
    },
    {
        reasonId: EmployeeModels.DE.BadgeReasonEnum.BadgeDamaged,
        name: 'Badge damaged ',
        placeholder: 'My badge is damaged',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/damaged.svg`
    }
];

export const INNITIAL_REQUEST_REASON: Array<RequestReason> = [
    {
        reasonId: EmployeeModels.DE.BadgeReasonEnum.InitialBadgeRequest,
        name: 'Initial badge request',
        placeholder: 'Badge is missing',
        icon: `${CommonConfig.employeeRequestReasonImgAssets}/no-photo.svg`
    }
];
